<template>
	<div class="" v-if="reasondetails.id > 0">


        <div class="clearfix">

            <div class="col-md-8 float-left mx-auto">
                <div><span class="text-secondary">Reason for Separation :</span> {{ reasondetails.title }}</div>
                <div><span class="text-secondary">Description :</span> {{ reasondetails.details }}</div>
            </div>

            <div class="col-md-4 float-right mx-auto">
                <div><span class="text-secondary">Status :</span> {{ status[reasondetails.status].text }}</div>
                <div><span class="text-secondary">Last Update :</span> {{formatDate(reasondetails.updated_at)}}</div>
                <div><span class="text-secondary">Default :</span> <template v-if="reasondetails.default_reason == 0">No</template><template v-else>Yes</template></div>
                <div><span class="text-secondary">Review Needed :</span> <template v-if="reasondetails.review_needed == 0">No</template><template v-else>Yes</template></div>

            </div>
        </div>

        <!-- Start: Rejwan: 08-12-2025 -->
        <hr class="ml-3">
        <b-button type="button" variant="primary" class="mb-3" @click="showRuleForm = !showRuleForm">Add Rule</b-button>
        <template v-if="showRuleForm">
          <div class="col-md-12 clearfix" style="">
              <input id="rule_id" name="rule_id" v-model="rule_id" type="hidden" />
              <b-form-group label="Effective Start Date [YYYY-MM-DD]" label-for="effective_start_date" class="half-width mr1 required-field">
                  <b-input-group class="mb-3">
                      <b-form-input id="effective_start_date" name="effective_start_date" placeholder="YYYY-MM-DD"
                          v-model="reasondetails.effective_start_date"
                          v-validate="{ required: true, date_format: 'yyyy-MM-dd' }" :state="!veeErrors.has('effective_start_date')" />
                      <b-input-group-append>
                          <b-form-datepicker v-model="reasondetails.effective_start_date" button-only right/>
                      </b-input-group-append>
                      <b-form-invalid-feedback>
                          {{ veeErrors.first('effective_start_date') }}
                      </b-form-invalid-feedback>
                  </b-input-group>
              </b-form-group>
              <b-form-group label="Effective End Date [YYYY-MM-DD]" label-for="effective_end_date" class="half-width mr1 required-field">
                  <b-input-group class="mb-3">
                      <b-form-input id="effective_end_date" name="effective_end_date" placeholder="YYYY-MM-DD"
                          v-model="reasondetails.effective_end_date" />
                      <b-input-group-append>
                          <b-form-datepicker v-model="reasondetails.effective_end_date" button-only right/>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
              <!-- Sohel: Introducing rules for pf settlement reasons -->
              <b-form-group id="caclulation_base-group" class="half-width mr1 required-field" label="Calculation Based On " label-for="caclulation_base">
                <b-form-select id="caclulation_base" name="caclulation_base" v-model="reasondetails.type" v-validate="{ required: true }" :options="base_options" :state="validateState('caclulation_base')" aria-describedby="caclulation_base-feedback" data-vv-as="Calculation Base Type"></b-form-select>
                <b-form-invalid-feedback id="caclulation_base-feedback">{{ veeErrors.first('caclulation_base') }}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group id="operator-group" class="half-width mr1 required-field" label="Operator to be used" label-for="operator">
                <b-form-select id="operator" name="operator" v-model="reasondetails.operator" v-validate="{ required: true }" :options="operators" :state="validateState('operator')" aria-describedby="operator-feedback" data-vv-as="Operator"></b-form-select>
                <b-form-invalid-feedback id="operator-feedback">{{ veeErrors.first('operator') }}</b-form-invalid-feedback>
              </b-form-group>
          </div>
          
        
          <hr class="ml-3">
          
          <div class="col-md-12" style="">
            <table class="table dataTable">
              <thead>

                  <tr class="table-head">
                      <td>Operator</td>
                      <td>Service Period Eligibility (months)</td>
                      <td>Month-to-Year Roundup (months)</td>
                      <td>Multiplication Factor *</td>
                      <td>Actions</td>
                  </tr>
              </thead>
              <tbody>
                <tr class="hover-bg table-row mx-2" v-for="(slab, n) in slabs">
                  <td>
                    {{ showOperator(reasondetails.operator) }}
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <!-- <b-form-checkbox v-model="slab.service_status" :value="1" :unchecked-value="0" switch></b-form-checkbox> -->
                      <b-form-input v-model="slab.service_month" type="number" :min="1"></b-form-input>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <!-- <b-form-checkbox v-model="slab.membership_status" :value="1" :unchecked-value="0" switch></b-form-checkbox> -->
                      <b-form-input v-model="slab.round_up_month" type="number" :min="1" :max="12"></b-form-input>
                    </div>
                  </td>
                  <td><b-form-input v-model="slab.multiplication" type="number" :min="1" step="1" @keypress="onlyInteger($event)" @blur="slab.multiplication = Math.max(1, parseInt(slab.multiplication) || 1)"></b-form-input></td>

                  <td><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5" @click="deleteRow(0, n)"></b-icon></td>
                </tr>
                      <tr class="hover-bg table-row mx-2">
                          <td colspan="2">Remaining Tenure</td>
                          <td><b-form-input value="0" :disabled="disable_remaining" ></b-form-input></td>
                          <td><b-form-input value="0" :disabled="disable_remaining"></b-form-input></td>
                      </tr>
              </tbody>

	    	    </table>
            
            <div class="m-4">                                                      
              <b-button type="button" variant="secondary" class="custom-wizard-btn" @click="addRow(0)">Add Slabs</b-button>
              
              <b-button type="button" variant="primary" class="custom-wizard-btn" @click="saveReasonSlabs(0)">Save</b-button>
            </div>
        
          </div>
        </template>
        <!-- End: Rejwan: 08-12-2025 -->

        
        <!-- Start: Rule List Accordion -->
        <template v-if="rule_slabs.length > 0">
          <b-card no-body>
            <b-tabs pills card vertical content-class="" nav-class="mr-1 pr-10 hide-content">
              <b-tab active>
                <template v-slot:title>
                  <b-icon icon="list-check"></b-icon> Rule List
                </template>

                <div class="card p-3 m-n2 acc-lists border-0 no-shadow">
                  <div role="tablist">
                    <b-card no-body class="mb-2 no-shadow" v-for="(item, index) in rule_slabs" :key="item.rule_id">
                      <b-card-header header-tag="header" class="p-0" role="tab">
                        <b-button
                          block
                          v-b-toggle="'accordion-' + item.rule_id"
                          variant="primary"
                        >
                          Rule #{{ item.rule_id }} |
                          {{ item.effective_start_date || 'Start?' }} →
                          {{ item.effective_end_date || 'Open' }}
                          <span class="when-opened float-right"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                          <span class="when-closed float-right"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        </b-button>
                      </b-card-header>

                      <b-collapse
                        :id="'accordion-' + item.rule_id"
                        accordion="my-rule-accordion"
                        role="tabpanel"
                        :visible="index === 0"
                      >
                        <b-card-body class="emp-acrdn position-relative">
                          <!-- === Rule Details === -->
                          <div class="col-md-12 clearfix" style="">
                            <input type="hidden" :id="'rule_id_' + item.rule_id" v-model="item.rule_id" />

                            <b-form-group
                              label="Effective Start Date [YYYY-MM-DD]"
                              :label-for="'start_' + item.rule_id"
                              class="half-width mr1 required-field"
                            >
                              <b-input-group class="mb-3">
                                <b-form-input
                                  :id="'start_' + item.rule_id"
                                  placeholder="YYYY-MM-DD"
                                  v-model="item.effective_start_date"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker v-model="item.effective_start_date" button-only right />
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>

                            <b-form-group
                              label="Effective End Date [YYYY-MM-DD]"
                              :label-for="'end_' + item.rule_id"
                              class="half-width mr1 required-field"
                            >
                              <b-input-group class="mb-3">
                                <b-form-input
                                  :id="'end_' + item.rule_id"
                                  placeholder="YYYY-MM-DD"
                                  v-model="item.effective_end_date"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker v-model="item.effective_end_date" button-only right />
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>

                            <b-form-group
                              label="Calculation Based On"
                              :label-for="'calc_' + item.rule_id"
                              class="half-width mr1 required-field"
                            >
                              <b-form-select
                                :id="'calc_' + item.rule_id"
                                v-model="item.type"
                                :options="base_options"
                              />
                            </b-form-group>

                            <b-form-group
                              label="Operator to be used"
                              :label-for="'op_' + item.rule_id"
                              class="half-width mr1 required-field"
                            >
                              <b-form-select
                                :id="'op_' + item.rule_id"
                                v-model="item.operator"
                                :options="operators"
                              />
                            </b-form-group>
                          </div>

                          <hr class="ml-3" />

                          <!-- === Slabs Table === -->
                          <div class="col-md-12" style="">
                            <table class="table dataTable">
                              <thead>
                                <tr class="table-head">
                                  <td>Operator</td>
                                  <td>Service Period Eligibility (months)</td>
                                  <td>Month-to-Year Roundup (months)</td>
                                  <td>Multiplication Factor *</td>
                                  <td>Actions</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  class="hover-bg table-row mx-2"
                                  v-for="(slab, n) in item.slabs"
                                  :key="item.rule_id + '-' + n"
                                >
                                  <td>{{ showOperator(item.operator) }}</td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <b-form-input v-model="slab.service_month" type="number" :min="1" />
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <b-form-input v-model="slab.round_up_month" type="number" :min="1" :max="12" />
                                    </div>
                                  </td>
                                  <td>
                                    <b-form-input v-model="slab.multiplication" type="number" :min="1" step="1" @keypress="onlyInteger($event)" @blur="slab.multiplication = Math.max(1, parseInt(slab.multiplication) || 1)" />
                                  </td>
                                  <td>
                                    <b-icon
                                      icon="trash-fill"
                                      aria-hidden="true"
                                      font-scale="1.5"
                                      @click="deleteRow(item.rule_id, n)"
                                    ></b-icon>
                                  </td>
                                </tr>

                                <tr class="hover-bg table-row mx-2">
                                  <td colspan="2">Remaining Tenure</td>
                                  <td><b-form-input value="0" :disabled="disable_remaining" /></td>
                                  <td><b-form-input value="0" :disabled="disable_remaining" /></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>

                            <div class="m-4">
                              <b-button
                                type="button"
                                variant="secondary"
                                class="custom-wizard-btn"
                                @click="addRow(item.rule_id)"
                              >
                                Add Slabs
                              </b-button>
                              <b-button
                                type="button"
                                variant="primary"
                                class="custom-wizard-btn"
                                @click="saveReasonSlabs(item.rule_id)"
                              >
                                Save
                              </b-button>
                              <b-button
                                type="button"
                                variant="primary"
                                class=""
                                @click="deleteRule(item.rule_id)"
                              >
                                Delete Rule
                              </b-button>
                            </div>
                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </template>
        <!-- End: Rule List Accordion -->

        
        <!-- Old section removed - replaced by accordion above -->
        <div class="clearfix mt-5" style="display: none;">
            <div class="col-md-6 float-left">
                <b-form-group id="calculation-group" label="Calculation Based On" label-for="calculation" class="required-field">
                    <b-form-select id="calculation" name="calculation" v-model="reasondetails.type" v-validate="{ required: true }" :options="calculation_list" :state="validateState('calculation')" aria-describedby="calculation-feedback" data-vv-as="Calculation Based On"></b-form-select>
                    <b-form-invalid-feedback id="calculation-feedback">{{ veeErrors.first('calculation') }}</b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-6 float-right">
                <b-form-group id="operator-group" label="Operator to be Used" label-for="operator" class="required-field">
                    <b-form-select id="operator" name="operator" v-model="reasondetails.operator" v-validate="{ required: true }" :options="operator_list" :state="validateState('operator')" aria-describedby="operator-feedback" data-vv-as="Operator to be Used"></b-form-select>
                    <b-form-invalid-feedback id="operator-feedback">{{ veeErrors.first('operator') }}</b-form-invalid-feedback>
                </b-form-group>
            </div>
        </div>

	    <hr class="ml-3" style="display: none;">


	    <div class="col-md-12" style="overflow-y: hidden; display: none;">
	    	<table class="table dataTable">
		    <thead>

		        <tr class="table-head">
		            <td>Operator</td>
		            <td>Service Period Eligibility (months)</td>
		            <td>Month-to-Year Roundup (months)</td>
		            <td>Multiplication Factor *</td>
		            <td>Actions</td>
		        </tr>
		    </thead>
		    <tbody>
		    	<tr class="hover-bg table-row mx-2" v-for="(slab, n) in slabs">
	    		  <td>
	    		     {{ showOperator(reasondetails.operator) }}
	    		  </td>
	    		  <td>
	    		    <div class="d-flex align-items-center">
	    		      <!-- <b-form-checkbox v-model="slab.service_status" :value="1" :unchecked-value="0" switch></b-form-checkbox> -->
	    		      <b-form-input v-model="slab.service_month" type="number" :min="1"></b-form-input>
	    		    </div>
	    		  </td>
	    		  <td>
	    		    <div class="d-flex align-items-center">
	    		      <!-- <b-form-checkbox v-model="slab.membership_status" :value="1" :unchecked-value="0" switch></b-form-checkbox> -->
	    		      <b-form-input v-model="slab.round_up_month" type="number" :min="1" :max="12"></b-form-input>
	    		    </div>
	    		  </td>
	    		  <td><b-form-input v-model="slab.multiplication" type="number" :min="1" step="1" @keypress="onlyInteger($event)" @blur="slab.multiplication = Math.max(1, parseInt(slab.multiplication) || 1)"></b-form-input></td>

	    		  <td><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5" @click="deleteRow(n)"></b-icon></td>
		    	</tr>
                <tr class="hover-bg table-row mx-2">
                    <td colspan="2">Remaining Tenure</td>
                    <td><b-form-input value="0" :disabled="disable_remaining" ></b-form-input></td>
                    <td><b-form-input value="0" :disabled="disable_remaining"></b-form-input></td>
                </tr>
		    </tbody>

	    	</table>

	    	<div class="m-4">
		    <b-button type="button" variant="secondary" class="custom-wizard-btn" @click="addRow">Add Slabs</b-button>

		    <b-button type="button" variant="primary" class="custom-wizard-btn" @click="saveReasonSlabs">Save</b-button>
		</div>

	    </div>
	</div>

</template>

<script>
    import moment from 'moment';
    export default{
        props: ['reason'],
        data(){
            return {
                // Sifat: 02-07-2025 Make monthly contribution run functional
                operators: [
                   { value: null, text: "Please Select" },
                   { value: 0, text: "Greater Than" },
                   { value: 1, text: "Equal or Greater Than" },
               ],
               // End: 02-07-2025 Make monthly contribution run functional

               reasondetails:{
                  type: null,
                  operator: null,
                  effective_start_date: null,
                  effective_end_date: ''
               },
               status: [
                        { value: "0", text: "Disabled" },
                        { value: "1", text: "Enable" },
                      ],

              slabs: [],

              fdata: {calculation: 0, operator: 0,},

              url : this.$api_url+'/gf/gf-policy-reason-slab/'+this.reason,

              base_options: [
                { value: null, text: "Please Select" },
                { value: "0", text: "Basic Salary" },
                { value: "1", text: "Gross Salary" },
              ],

              calculation_list: [
                { value: "0", text: "Basic Salary" },
                { value: "1", text: "Gross Salary" },
              ],
            // Sifat: 02-07-2025 Make monthly contribution run functional
              operator_list: [
                { value: "0", text: "Greater Than" },
                { value: "1", text: "Equal or Greater Than" },
              ],
              // End: 02-07-2025 Make monthly contribution run functional
              disable_remaining:true,
              showRuleForm: false,
              rule_id: 0,
              rule_slabs: [],
            }
        },
        methods:{
            formatDate(d)
            {
                return moment(d).format('DD-MM-YYYY');
            },
            showOperator(value)
            {
                // Find the object with the given value
                const reason = this.operators.find(item => item.value === value);

                // Return the text if found, otherwise return a default message
                return reason ? reason.text : "Reason not found";
            },
            deleteRow(ruleId = 0, index){
                if (ruleId > 0) {
                    // existing rule tab
                    const rule = this.rule_slabs.find(r => r.rule_id === ruleId);
                    if (!rule || !Array.isArray(rule.slabs)) return;
                    rule.slabs.splice(index, 1);
                } else {
                    // new rule form
                    if (!Array.isArray(this.slabs)) return;
                    this.slabs.splice(index, 1);
                }
            },
            addRow: function (ruleId = 0) {
                if (ruleId > 0) {
                    // existing rule tab
                    const rule = this.rule_slabs.find(r => r.rule_id === ruleId);
                    if (!rule) return;
                    if (!Array.isArray(rule.slabs)) this.$set(rule, 'slabs', []);
                    rule.slabs.push({
                        service_month: 0,
                        round_up_month: 0,
                        multiplication: 1
                    });
                } else {
                    // new rule form
                    if (!Array.isArray(this.slabs)) this.slabs = [];
                    this.slabs.push({
                        service_month: 0,
                        round_up_month: 0,
                        multiplication: 1
                    });
                }
            },

            getReason: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/gf/gf-policy-reason/'+this.reason ).then(function(response){

                  this.reasondetails = response.data;

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            getReasonSlabs: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.url ).then(function(response){

                  // this.slabs = response.data;
                  this.rule_slabs = response.data;

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            saveReasonSlabs: function(rule_id = 0)
            {
                if(!this.checkNet()) return false;

                this.$validator.validateAll().then(result => {
                  if (!result) {
                      return;
                  }

                  let payload = {};

                  if (rule_id > 0) {
                      // Saving existing rule tab
                      const rule = this.rule_slabs.find(r => r.rule_id === rule_id);
                      if (!rule) return;

                      payload = {
                          rule_id: rule.rule_id,
                          reasondetails: {
                              effective_start_date: rule.effective_start_date,
                              effective_end_date: rule.effective_end_date,
                              type: rule.type,
                              operator: rule.operator
                          },
                          slabs: rule.slabs
                      };
                  } else {
                      // Saving new rule form
                      payload = {
                          rule_id: 0,
                          reasondetails: this.reasondetails,
                          slabs: this.slabs
                      };
                  }

                  let currentObj = this;
                  axios.post(this.url, payload)
                    .then(function (response)
                    {

                      this.$bvToast.toast('Saved!', {
                              title: `Success`,
                              variant: 'success',
                              solid: true
                          });
                      currentObj.$emit('submission-success');
                      // currentObj.getReasonSlabs(); // refresh after save
                      
                      // if (rule_id === 0) {
                      //     // reset form after creating
                      //     currentObj.reasondetails = {
                      //         type: null,
                      //         operator: null,
                      //         effective_start_date: null,
                      //         effective_end_date: ''
                      //     };
                      //     currentObj.slabs = [];
                      //     currentObj.showRuleForm = false;
                      // }

                    }.bind(this))
                    .catch(function (error)
                    {
                      let message = 'An error occurred while saving.';

                      // Laravel-style errors
                      if (error.response && error.response.data) {
                        if (typeof error.response.data === 'string') {
                          message = error.response.data;
                        } else if (error.response.data.error) {
                          message = error.response.data.error;
                        } else if (error.response.data.message) {
                          message = error.response.data.message;
                        }
                      }

                      currentObj.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                      });
                    });

                });
            },

            deleteRule(rule_id = 0) {
                if (!this.checkNet()) return false;

                let payload = {
                    rule_id: rule_id
                };

                let currentObj = this;
                axios.post(this.$api_url+'/gf/gf-policy-reason-rule/delete', payload)
                    .then(function (response) {
                        if (response.data && response.data.status === 'deleted') {
                            currentObj.$bvToast.toast('Rule deleted successfully.', {
                                title: 'Success',
                                variant: 'success',
                                solid: true
                            });
                        }
                        currentObj.getReasonSlabs(); // refresh after delete
                    }.bind(this))
                    .catch(function (error) {
                        let message = 'An error occurred while deleting.';

                        // Laravel-style errors
                        if (error.response && error.response.data) {
                            if (typeof error.response.data === 'string') {
                                message = error.response.data;
                            } else if (error.response.data.error) {
                                message = error.response.data.error;
                            } else if (error.response.data.message) {
                                message = error.response.data.message;
                            }
                        }

                        currentObj.$bvToast.toast(message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    });
            },

        },
        created: function(){

          this.getReason();
          this.getReasonSlabs();

      },
    }
</script>